import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { usePageMetadata } from "../context/PageMetadataContext";
import { horizon } from "../api/horizon";
import CopyIcon from "../components/CopyIcon";
import { timelib } from "../utils/time";
import { Button, Card, Spinner, Table } from "react-bootstrap";
import OperationText from "../components/OperationText";
import AccountLabel from "../components/AccountLabel";
import { okx } from "../api/okx";
import { useLanguage } from "../context/LanguageContext";
import { CardContent } from "../components/Card";
import AdSenseUnit from "../components/AdsenseUnit";
import AdUnit from "../components/AdUnit";

const Operations: React.FC = () => {
  const { t, language } = useLanguage();
  const [operations, setOperations] = useState<any[]>([]);
  const { setHeading, setTitle, setDescription } = usePageMetadata();
  const [txNextLink, setTxNextLink] = useState("");
  const [txPrevLink, setTxPrevLink] = useState("");
  const [txPage, setTxPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [piPriceUSD, setPiPriceUSD] = useState(0.0);

  const fetchOperations = async (Link = "", page = 1) => {
    try {
      setLoading(true);
      const response = await horizon.getLatestOperations(Link, 20);
      //if order asc, reverse the array, and next is prev and prev is next
      if (Link==""||Link.indexOf("order=desc") > 0) {
        setOperations(response._embedded.records);
        setTxNextLink(response._links.next.href);
        setTxPrevLink(response._links.prev.href);
        setTxPage(page);
      }
      else{
        setOperations(response._embedded.records.reverse());
        setTxNextLink(response._links.prev.href);
        setTxPrevLink(response._links.next.href);
        setTxPage(page);
      }
    } catch (error) {
      console.error("Error fetching Operations:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchPiPrice = async () => {
    try {
      okx.getMarketData().then(marketData => {
        // Market Stats
        setPiPriceUSD(parseFloat(marketData.idxPx));
      });
    } catch (error) {
      console.error("Error fetching Pi price:", error);
    }
  };

  useEffect(() => {
    fetchPiPrice();
  }, []);

  useEffect(() => {
    // Set page metadata with translations
    setHeading(t('operations.heading'));
    setTitle(t('operations.title'));
    setDescription(t('operations.description'));
  }, [setTitle, setDescription, setHeading, language, t]);

  useEffect(() => {
    fetchOperations();
  }, []);

  // Format amount based on user's locale
  const formatAmount = (amount: number): string => {
    return amount.toLocaleString(language, { 
      minimumFractionDigits: 0, 
      maximumFractionDigits: 3 
    });
  };

  return (
    <div className="">
      {loading ? (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div>
            <div className="col-md-12">
                <Card className="none-radius">
                    <CardContent>
                        <h5 className="card-title" style={{fontSize:"16px",marginBottom:"20px"}}>{t('operations.title')}</h5>
          <Table hover responsive className="mt-3">
            <thead>
              <tr>
                <th>{t('operations.source_account')}</th>
                <th>{t('operations.operation')}</th>
                <th>{t('operations.amount')}</th>
                <th>{t('operations.tx')}</th>
                <th>{t('operations.time')}</th>
              </tr>
            </thead>
            <tbody>
              {operations.map((op) => (
                <tr key={op.id}>
                  <td>
                    <AccountLabel account={op.source_account} shorten={true}/>
                  </td>
                  <td><OperationText op={op} PiPrice={piPriceUSD}/></td>
                  <td style={{fontWeight:"500"}}>
                    {op.amount ? formatAmount(parseFloat(op.amount)) : ""}
                  </td>
                  <td>
                    <Link to={`/tx/${op.transaction_hash}`} className="text-decoration-none">
                      {op.transaction_hash.slice(0, 16)}...
                    </Link>
                    {" "}
                    <CopyIcon textToCopy={op.transaction_hash} />
                  </td>
                  <td>{timelib.timeAgo(op.created_at, language)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="d-flex justify-content-between align-items-center mt-4">
            <Button
              size="sm"
              variant="primary"
              onClick={() => fetchOperations(txPrevLink, txPage - 1)}
              disabled={!txPrevLink || loading || txPage === 1}
            >
              {t('pagination.previous')}
            </Button>
            <span className="mx-3">{t('pagination.page')} {txPage}</span>
            <Button
              size="sm"
              variant="primary"
              onClick={() => fetchOperations(txNextLink, txPage + 1)}
              disabled={!txNextLink || loading}
            >
              {t('pagination.next')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
    <div className="row g-3 mb-4  d-block d-md-none">
        {/* <AdSenseUnit/> */}
        {/* <AdUnit
                  className="67cc9f95aa72d3d47fe128c2"
                  width="300px"
                  height="100px"
                  centered={true}
                /> */}
      </div>
  </div>
      )}
    </div>
  );
};

export default Operations;
